import { useState } from 'react';

interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    id: 1,
    category: '訂購相關',
    question: '如何下單購買花禮？',
    answer: '您可以直接在網站上瀏覽我們的花禮商品，選擇喜歡的款式後點擊「加入購物車」，填寫收件人資訊和配送時間，選擇付款方式後即可完成訂購。我們提供線上刷卡、ATM 轉帳等多種付款方式，訂單確認後會立即開始製作。'
  },
  {
    id: 2,
    category: '訂購相關',
    question: '有哪些付款方式？',
    answer: '我們提供多元的付款方式，包括：信用卡線上刷卡、ATM 轉帳、超商代碼繳費。所有付款方式都經過加密保護，確保您的交易安全。付款完成後系統會自動發送確認信至您的電子信箱。'
  },
  {
    id: 3,
    category: '訂購相關',
    question: '下單後多久會收到訂單確認？',
    answer: '訂單送出並完成付款後，系統會立即發送訂單確認信至您的註冊信箱。我們的客服團隊會在 2 小時內（營業時間）再次確認訂單細節，並通知您預計的製作與配送時間。如有任何問題，我們會主動與您聯繫。'
  },
  {
    id: 4,
    category: '配送相關',
    question: '配送範圍包含哪些地區？',
    answer: '我們提供全台灣本島配送服務，包含台北、新北、桃園、台中、台南、高雄等主要城市，以及其他縣市鄉鎮地區。離島地區（金門、馬祖、澎湖、綠島、蘭嶼）因運送條件限制，需另外洽詢客服評估配送可行性與運費。'
  },
  {
    id: 5,
    category: '配送相關',
    question: '可以指定配送時間嗎？',
    answer: '可以的！您可以在下單時選擇希望的配送日期與時段（上午 9-12 點、下午 13-18 點、晚上 18-21 點）。我們會盡力配合您指定的時間送達，但實際配送時間可能因交通狀況略有調整。如需精確時間配送，建議提前與客服聯繫安排。'
  },
  {
    id: 6,
    category: '配送相關',
    question: '可以到店自取嗎？',
    answer: '當然可以！如果您方便到店取貨，下單時請選擇「門市自取」選項，並在備註欄註明預計取貨時間。我們會在花禮製作完成後通知您，您可以親自到店挑選並取貨。自取訂單可享免運費優惠，且能當面確認花禮品質。'
  },
  {
    id: 7,
    category: '節日預約相關',
    question: '節日花禮需要提前多久預約？',
    answer: '為確保節日當天能準時收到精美的花禮，建議您至少提前 3-5 天預約。熱門節日如母親節、情人節、聖誕節等，建議提前 7-14 天預約，以確保我們有充足時間準備最新鮮的花材並完成精緻的設計。越早預約，花材選擇越豐富！'
  },
  {
    id: 8,
    category: '節日預約相關',
    question: '預約後可以修改或取消嗎？',
    answer: '預約確認後，如需修改配送資訊、花禮款式或卡片內容，請在配送日前 2 天聯繫客服協助處理。若需取消預約，配送日前 3 天取消可全額退款，前 2 天取消收取 30% 手續費，前 1 天或當天取消恕不退款（因花材已備料製作）。'
  },
  {
    id: 9,
    category: '會員點數相關',
    question: '如何獲得會員點數？',
    answer: '會員點數獲得方式包括：(1) 新會員註冊即贈 100 點；(2) 每消費 1 元可累積 1 點；(3) 生日當月贈送 200 點；(4) 參加官網活動或推薦好友註冊可獲得額外點數。點數可在下次購物時折抵現金使用，讓您享受更多優惠！'
  },
  {
    id: 10,
    category: '會員點數相關',
    question: '點數如何使用？有效期限多久？',
    answer: '會員點數可在結帳時直接折抵現金使用，1 點 = 1 元，每筆訂單最多可使用訂單金額的 30%。點數自獲得日起有效期限為 1 年，即將到期的點數會在會員中心顯示提醒。建議您定期查看點數餘額，把握使用期限享受優惠！'
  }
];

export default function FAQ() {
  const [openId, setOpenId] = useState<number>(1);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section id="faq" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
            常見問題
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            為您整理最常見的問題與解答，讓您更了解我們的服務
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-white border-2 border-gray-100 rounded-xl overflow-hidden hover:border-[#14B8A6]/30 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4 text-left hover:bg-gray-50/50 transition-colors duration-200 cursor-pointer"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2 sm:gap-3 mb-1.5 sm:mb-2">
                    <span className="inline-block px-2.5 sm:px-3 py-1 bg-[#14B8A6]/10 text-[#14B8A6] text-xs sm:text-sm font-semibold rounded-full whitespace-nowrap">
                      {faq.category}
                    </span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-[#2C2C2C] leading-relaxed">
                    {faq.question}
                  </h3>
                </div>
                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-xl sm:text-2xl text-[#14B8A6] transition-transform duration-300 ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 sm:px-6 pb-4 sm:pb-5 pt-0">
                  <div className="pl-0 border-l-4 border-[#14B8A6]/20 pl-4 sm:pl-5">
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 text-center">
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-5">
            還有其他問題嗎？歡迎隨時與我們聯繫
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 bg-[#14B8A6] text-white font-semibold rounded-xl hover:bg-[#0F9A8A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <i className="ri-customer-service-2-line text-lg sm:text-xl"></i>
            聯繫客服
          </a>
        </div>
      </div>
    </section>
  );
}